var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_2137_7453)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0679 19.8743C18.0679 18.3784 19.2806 17.1658 20.7765 17.1658H33.4165C34.9124 17.1658 36.1251 18.3784 36.1251 19.8743V36.1258C36.1251 37.6216 34.9124 38.8343 33.4165 38.8343H20.7765C19.2806 38.8343 18.0679 37.6216 18.0679 36.1258V34.7715H16.7137C15.9657 34.7715 15.3594 34.1651 15.3594 33.4172C15.3594 32.6693 15.9657 32.0629 16.7137 32.0629H18.0679V29.3543H16.7137C15.9657 29.3543 15.3594 28.748 15.3594 28.0001C15.3594 27.2521 15.9657 26.6458 16.7137 26.6458H18.0679V23.9372H16.7137C15.9657 23.9372 15.3594 23.3309 15.3594 22.5829C15.3594 21.835 15.9657 21.2286 16.7137 21.2286H18.0679V19.8743ZM40.6394 20.7772C40.6394 20.0293 40.033 19.4229 39.2851 19.4229C38.5372 19.4229 37.9308 20.0293 37.9308 20.7772V22.5829C37.9308 23.3309 38.5372 23.9372 39.2851 23.9372C40.033 23.9372 40.6394 23.3309 40.6394 22.5829V20.7772ZM39.2851 25.7429C40.033 25.7429 40.6394 26.3493 40.6394 27.0972V28.9029C40.6394 29.6509 40.033 30.2572 39.2851 30.2572C38.5372 30.2572 37.9308 29.6509 37.9308 28.9029V27.0972C37.9308 26.3493 38.5372 25.7429 39.2851 25.7429ZM24.8394 22.3572C24.2161 22.3572 23.7108 22.8625 23.7108 23.4858C23.7108 24.1091 24.2161 24.6143 24.8394 24.6143H29.3537C29.977 24.6143 30.4822 24.1091 30.4822 23.4858C30.4822 22.8625 29.977 22.3572 29.3537 22.3572H24.8394Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_7453",
    x1: -6.00482,
    y1: 61.32,
    x2: 67.2446,
    y2: 57.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address_book.18b463789003aba59ee1c653838d2633.svg";
export { ForwardRef as ReactComponent };